import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  locationContent: '',
  navContent: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_HELP_AND_ANSWER.SUCCESS: {
      const { type } = action.payload;
      if (type === 'verifyLocations') {
        INITIAL_STATE.locationContent = action.payload.content;
      } else {
        INITIAL_STATE.navContent = action.payload.content;
      }
      return {
        ...state,
        ...INITIAL_STATE,
      };
    }
    default:
      return state;
  }
};
